import { Injectable } from "@angular/core";
import { AreaCommonDropDown, CommonDropDown, EnumValueCommonDropDown, SingleCommonDropDown } from "../types/dropdown.types";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "environments/environment";
import { BaseRespone } from "app/core/models/common.response";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map, tap } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class LookupService {
    private _banks: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _bankBranches: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _zones: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _optionTypes: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _teams: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _consultants: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _areas: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _users: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _inactiveUsers: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _partyNames: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _societyNames: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _loanDepartment: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _categories: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _bankAccountDetail: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _options: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _userRoles: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _invoiceNumbers: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _propertyCity: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _propertyArea: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _propertyLandmark: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _propertyWardNos: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _propertyTpsno: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _propertyFpno: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _templates: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _remarknames: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _reportsettingfields: BehaviorSubject<EnumValueCommonDropDown[] | null> = new BehaviorSubject(null);
    private _cities: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);
    private _areaName: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _floorProperty: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _propertyRsno: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _propertyBlockNo: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _consultantDSANames: BehaviorSubject<SingleCommonDropDown[] | null> = new BehaviorSubject(null);
    private _expenseCategories: BehaviorSubject<CommonDropDown[] | null> = new BehaviorSubject(null);

    /**
     *
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
    }

    get banks$(): Observable<CommonDropDown[]> {
        return this._banks.asObservable();
    }

    get categories$(): Observable<CommonDropDown[]> {
        return this._categories.asObservable();
    }

    get partyNames$(): Observable<SingleCommonDropDown[]> {
        return this._partyNames.asObservable();
    }

    get societyNames$(): Observable<SingleCommonDropDown[]> {
        return this._societyNames.asObservable();
    }

    get teams$(): Observable<CommonDropDown[]> {
        return this._teams.asObservable();
    }

    get bankBranches$(): Observable<CommonDropDown[]> {
        return this._bankBranches.asObservable();
    }

    get zones$(): Observable<CommonDropDown[]> {
        return this._zones.asObservable();
    }

    get optionTypes$(): Observable<CommonDropDown[]> {
        return this._optionTypes.asObservable();
    }

    get consultants$(): Observable<CommonDropDown[]> {
        return this._consultants.asObservable();
    }

    get areas$(): Observable<AreaCommonDropDown[]> {
        return this._areas.asObservable();
    }

    get users$(): Observable<CommonDropDown[]> {
        return this._users.asObservable();
    }

    get inactiveUsers$(): Observable<CommonDropDown[]> {
        return this._inactiveUsers.asObservable();
    }

    get loanDepartments$(): Observable<CommonDropDown[]> {
        return this._loanDepartment.asObservable();
    }

    get bankAccountDetail$(): Observable<CommonDropDown[]> {
        return this._bankAccountDetail.asObservable();
    }
    get userRoles$(): Observable<CommonDropDown[]> {
        return this._userRoles.asObservable();
    }
    get invoiceNumbers$(): Observable<CommonDropDown[]> {
        return this._invoiceNumbers.asObservable();
    }
    get propertyCities$(): Observable<SingleCommonDropDown[]> {
        return this._propertyCity.asObservable();
    }
    get propertyAreas$(): Observable<SingleCommonDropDown[]> {
        return this._propertyArea.asObservable();
    }
    get propertyLandmarks$(): Observable<SingleCommonDropDown[]> {
        return this._propertyLandmark.asObservable();
    }
    get propertyWardNos$(): Observable<SingleCommonDropDown[]> {
        return this._propertyWardNos.asObservable();
    }
    get propertyTpsnos$(): Observable<SingleCommonDropDown[]> {
        return this._propertyTpsno.asObservable();
    }
    get propertyFpnos$(): Observable<SingleCommonDropDown[]> {
        return this._propertyFpno.asObservable();
    }
    get templates$(): Observable<CommonDropDown[]> {
        return this._templates.asObservable();
    }
    get remarknames$(): Observable<CommonDropDown[]> {
        return this._remarknames.asObservable();
    }
    get reportsettingfields$(): Observable<EnumValueCommonDropDown[]> {
        return this._reportsettingfields.asObservable();
    }
    get cities$(): Observable<CommonDropDown[]> {
        return this._cities.asObservable();
    }
    get areaNames$(): Observable<SingleCommonDropDown[]> {
        return this._areaName.asObservable();
    }
    get floorProperty$(): Observable<SingleCommonDropDown[]> {
        return this._floorProperty.asObservable();
    }
    get propertyRsnos$(): Observable<SingleCommonDropDown[]> {
        return this._propertyRsno.asObservable();
    }
    get propertyBlockNos$(): Observable<SingleCommonDropDown[]> {
        return this._propertyBlockNo.asObservable();
    }
    get consultantDSANames$(): Observable<SingleCommonDropDown[]> {
        return this._consultantDSANames.asObservable();
    }
    get expenseCategories$(): Observable<CommonDropDown[]> {
        return this._expenseCategories.asObservable();
    }


    getBanks(value?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetBanks`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._banks.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetBanks`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._banks.next(response);
                    })
                );
        }
    }

    getBankBranches(bankId: number, value?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetBankBranches`, { params: { bankId, value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._bankBranches.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetBankBranches`, { params: { bankId } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._bankBranches.next(response);
                    })
                );
        }
    }

    getZones(value?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetZones`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._zones.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetZones`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._zones.next(response);
                    })
                );
        }
    }

    getOptionTypes(value?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetOptionTypes`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._optionTypes.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetOptionTypes`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._optionTypes.next(response);
                    })
                );
        }
    }

    getTeams(value?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetTeams`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._teams.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetTeams`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._teams.next(response);
                    })
                );
        }
    }

    getConsultants(value?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetConsultants`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._consultants.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetConsultants`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._consultants.next(response);
                    })
                );
        }
    }

    getAreas(value?: string): Observable<AreaCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<AreaCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetAreas`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._areas.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<AreaCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetAreas`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._areas.next(response);
                    })
                );
        }
    }

    getUsers(value?: string, userId?: number, isActive: boolean = true): Observable<CommonDropDown[]> {
        const params: { [key: string]: string | number | boolean } = { isActive };

        if (value) {
            params.value = value;
        }
        if (userId) {
            params.userId = userId;
        }

        return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetUsers`, { params }
        ).pipe(
            map(response => response.result),
            tap((response) => this._users.next(response))
        );
    }

    getInactiveUsers(value?: string, userId?: number, isActive: boolean = false): Observable<CommonDropDown[]> {
        const params: { [key: string]: string | number | boolean } = { isActive };

        if (value) {
            params.value = value;
        }
        if (userId) {
            params.userId = userId;
        }

        return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetUsers`, { params }
        ).pipe(
            map(response => response.result),
            tap((response) => this._inactiveUsers.next(response))
        );
    }

    getPartyNames(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPartyNames`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._partyNames.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPartyNames`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._partyNames.next(response);
                    })
                );
        }
    }

    getSocietyNames(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetSocieties`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._societyNames.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetSocieties`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._societyNames.next(response);
                    })
                );
        }
    }

    getLoanDepartment(value?: string, bankId?: number): Observable<CommonDropDown[]> {
        const params: any = {};

        if (value) {
            params.value = value;
        }

        if (bankId !== undefined && bankId !== null) {
            params.bankId = bankId;
        }

        return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetLoanDepartments`, { params })
            .pipe(
                map(response => {
                    return response.result;
                }),
                tap((response) => {
                    this._loanDepartment.next(response);
                })
            );
    }

    getCategories(value?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/getCategories`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._categories.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/getCategories`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._categories.next(response);
                    })
                );
        }
    }

    getbankAccountDetails(value?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/getbankAccountDetails`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._bankAccountDetail.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/getBankAccountDetails`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._bankAccountDetail.next(response);
                    })
                );
        }
    }

    getOptionByTypeId(value?: number, reportType?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetOptions?typeId=${value}&reportType=${reportType}`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._options.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetOptions?reportType=${reportType}`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._options.next(response);
                    })
                );
        }
    }

    getUserRoles(value?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetUserRoles`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._userRoles.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetUserRoles`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._userRoles.next(response);
                    })
                );
        }
    }

    getInvoiceNumbers(value?: number): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetInvoiceNumber`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._invoiceNumbers.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetInvoiceNumber`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._invoiceNumbers.next(response);
                    })
                );
        }
    }
    getPropertyCity(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyCities`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyCity.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyCities`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyCity.next(response);
                    })
                );
        }
    }
    getPropertyArea(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyAreas`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyArea.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyAreas`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyArea.next(response);
                    })
                );
        }
    }
    getPropertyLandmark(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyLandmarks`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyLandmark.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyLandmarks`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyLandmark.next(response);
                    })
                );
        }
    }
    getPropertyWardNos(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyWardNos`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyWardNos.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyWardNos`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyWardNos.next(response);
                    })
                );
        }
    }
    getPropertyTpsno(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyTpsno`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyTpsno.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyTpsno`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyTpsno.next(response);
                    })
                );
        }
    }
    getPropertyFpno(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyFpno`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyFpno.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyFpno`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyFpno.next(response);
                    })
                );
        }
    }
    getPropertyFloor(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyFloor`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyFpno.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyFloor`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyFpno.next(response);
                    })
                );
        }
    }

    getTemplates(value?: string, bankId?: number, templateType?: string, reportType?: string): Observable<CommonDropDown[]> {

        var url = `${environment.baseUrl}/Lookup/GetTemplates`

        let params = new HttpParams();
        if (value) {
            params = params.set('value', value);
        }
        if (bankId) {
            params = params.set('bankId', bankId.toString());
        }
        if (templateType) {
            params = params.set('templateType', templateType);
        }
        if (reportType) {
            params = params.set('reportType', reportType);
        }

        if (params) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetTemplates`, { params })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._templates.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetTemplates`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._templates.next(response);
                    })
                );
        }
    }

    getRemarkNames(value?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetRemarks`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._remarknames.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetRemarks`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._remarknames.next(response);
                    })
                );
        }
    }

    GetReportSettingField(): Observable<EnumValueCommonDropDown[]> {
        return this._httpClient.get<BaseRespone<EnumValueCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetReportSettings`)
            .pipe(
                map(response => {
                    return response.result
                }),
                tap((response) => {
                    this._reportsettingfields.next(response);
                })
            );
    }

    getCities(value?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetCities`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._cities.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetCities`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._cities.next(response);
                    })
                );
        }
    }
    getAreaName(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetAreaName`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._areaName.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetAreaName`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._areaName.next(response);
                    })
                );
        }
    }

    getPropertyRsno(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyRsno`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyRsno.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyRsno`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyRsno.next(response);
                    })
                );
        }
    }

    getPropertyBlockNo(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyBlockNo`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyBlockNo.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetPropertyBlockNo`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._propertyBlockNo.next(response);
                    })
                );
        }
    }

    GetConsultantDSANames(value?: string): Observable<SingleCommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetConsultantDSANames`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._consultantDSANames.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<SingleCommonDropDown[]>>(`${environment.baseUrl}/Lookup/GetConsultantDSANames`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._consultantDSANames.next(response);
                    })
                );
        }
    }

    getExpenseCategories(value?: string): Observable<CommonDropDown[]> {
        if (value) {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/ExpenseCategory`, { params: { value } })
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._expenseCategories.next(response);
                    })
                );
        }
        else {
            return this._httpClient.get<BaseRespone<CommonDropDown[]>>(`${environment.baseUrl}/Lookup/ExpenseCategories`)
                .pipe(
                    map(response => {
                        return response.result
                    }),
                    tap((response) => {
                        this._expenseCategories.next(response);
                    })
                );
        }
    }
}
